import types from 'constants/actionTypes';

export const setSelectedOptions = options => ({
  type: types.SET_SELECTED_OPTIONS,
  payload: options,
});
